// WARNING: DO NOT EDIT THIS FILE MANUALLY, USE `yarn svgr-ui-kit` INSTEAD!

import alcmeon from "./alcmeon";
import alcmeonUntinted from "./alcmeonUntinted";
import arobase from "./arobase";
import arrowDown from "./arrowDown";
import arrowLeft from "./arrowLeft";
import arrowRight from "./arrowRight";
import arrowSort from "./arrowSort";
import arrowUp from "./arrowUp";
import arrowsCrossing from "./arrowsCrossing";
import arrowsInvert from "./arrowsInvert";
import arrowsReduce from "./arrowsReduce";
import arrowsShrinking from "./arrowsShrinking";
import arrowsSpin from "./arrowsSpin";
import arrowsSpread from "./arrowsSpread";
import arrowsStretching from "./arrowsStretching";
import asterisk from "./asterisk";
import bang from "./bang";
import bangFat from "./bangFat";
import barchart from "./barchart";
import bilibili from "./bilibili";
import blog from "./blog";
import bookmark from "./bookmark";
import boxes from "./boxes";
import bubble from "./bubble";
import bubbleBang from "./bubbleBang";
import bubbleComment from "./bubbleComment";
import bubbleDollar from "./bubbleDollar";
import bubbleDots from "./bubbleDots";
import bubbleGraph from "./bubbleGraph";
import bubbleLines from "./bubbleLines";
import bubblePencil from "./bubblePencil";
import bubblePress from "./bubblePress";
import bubbleRetweet from "./bubbleRetweet";
import bubbles from "./bubbles";
import calendar from "./calendar";
import camera from "./camera";
import candles from "./candles";
import carGauge from "./carGauge";
import chartUp from "./chartUp";
import check from "./check";
import checkFat from "./checkFat";
import checkboxFalse from "./checkboxFalse";
import checkboxTrue from "./checkboxTrue";
import chevronDown from "./chevronDown";
import chevronLeft from "./chevronLeft";
import chevronRight from "./chevronRight";
import chevronSmallDown from "./chevronSmallDown";
import chevronSmallLeft from "./chevronSmallLeft";
import chevronSmallRight from "./chevronSmallRight";
import chevronSmallUp from "./chevronSmallUp";
import chevronUp from "./chevronUp";
import circleBan from "./circleBan";
import circleBang from "./circleBang";
import circleCross from "./circleCross";
import circleHalf from "./circleHalf";
import circleInfo from "./circleInfo";
import circleList from "./circleList";
import circleMagnifier from "./circleMagnifier";
import circleQuestion from "./circleQuestion";
import circleUser from "./circleUser";
import circles from "./circles";
import clock from "./clock";
import close from "./close";
import cog from "./cog";
import comment from "./comment";
import corners from "./corners";
import cornersPlus from "./cornersPlus";
import cornersTag from "./cornersTag";
import critizr from "./critizr";
import cross from "./cross";
import crossThick from "./crossThick";
import dailymotion from "./dailymotion";
import danmaku from "./danmaku";
import dash from "./dash";
import dashboard from "./dashboard";
import dashboardChart from "./dashboardChart";
import dashboardCustom from "./dashboardCustom";
import device from "./device";
import disc from "./disc";
import discClose from "./discClose";
import discPause from "./discPause";
import discQuestion from "./discQuestion";
import discoveryHeroMagicWand from "./discoveryHeroMagicWand";
import dislike from "./dislike";
import dots3H from "./dots3H";
import dots3V from "./dots3V";
import dotsGrid from "./dotsGrid";
import douyin from "./douyin";
import emoji from "./emoji";
import engagement from "./engagement";
import envelope from "./envelope";
import envelopes from "./envelopes";
import exit from "./exit";
import eye from "./eye";
import eyeCrossed from "./eyeCrossed";
import eyedropper from "./eyedropper";
import facebook from "./facebook";
import facebookPage from "./facebookPage";
import facebookPerson from "./facebookPerson";
import facebookReactionAngry from "./facebookReactionAngry";
import facebookReactionHaha from "./facebookReactionHaha";
import facebookReactionLike from "./facebookReactionLike";
import facebookReactionLove from "./facebookReactionLove";
import facebookReactionSad from "./facebookReactionSad";
import facebookReactionWow from "./facebookReactionWow";
import feed from "./feed";
import female from "./female";
import flag from "./flag";
import focus from "./focus";
import folder from "./folder";
import folderFunnel from "./folderFunnel";
import folderMagnifier from "./folderMagnifier";
import forum from "./forum";
import frameChart from "./frameChart";
import frameText from "./frameText";
import funnel from "./funnel";
import funnelCog from "./funnelCog";
import funnelFilled from "./funnelFilled";
import funnelMinus from "./funnelMinus";
import funnelPencil from "./funnelPencil";
import funnelPlus from "./funnelPlus";
import genders from "./genders";
import geomark from "./geomark";
import geomark2 from "./geomark2";
import geomarks from "./geomarks";
import ghost from "./ghost";
import github from "./github";
import gplus from "./gplus";
import graph from "./graph";
import graphArrow from "./graphArrow";
import graphLines from "./graphLines";
import graphPodium from "./graphPodium";
import grid from "./grid";
import gridSquares from "./gridSquares";
import grip from "./grip";
import groupBubblesEmpty from "./groupBubblesEmpty";
import gunsight from "./gunsight";
import hashtag from "./hashtag";
import heart from "./heart";
import home from "./home";
import hourglassArrowCross from "./hourglassArrowCross";
import hspAssign from "./hspAssign";
import hspReply from "./hspReply";
import hspRetweet from "./hspRetweet";
import i from "./i";
import id from "./id";
import image from "./image";
import instagram from "./instagram";
import instagramBusiness from "./instagramBusiness";
import instagramPersonal from "./instagramPersonal";
import instagramUntinted from "./instagramUntinted";
import layout1Col from "./layout1Col";
import layout2Cols from "./layout2Cols";
import layout3Cols from "./layout3Cols";
import lightbulb from "./lightbulb";
import like from "./like";
import lines3V from "./lines3V";
import link from "./link";
import linkedin from "./linkedin";
import linkfluence from "./linkfluence";
import list from "./list";
import listClose from "./listClose";
import listOpen from "./listOpen";
import littleredbook from "./littleredbook";
import liveHelp from "./liveHelp";
import loDash from "./loDash";
import loadDown from "./loadDown";
import loadUp from "./loadUp";
import loader from "./loader";
import localisation from "./localisation";
import magic from "./magic";
import magicWand from "./magicWand";
import magicWandCursor from "./magicWandCursor";
import magicWandGradient from "./magicWandGradient";
import magnifier from "./magnifier";
import magnifierPlus from "./magnifierPlus";
import male from "./male";
import masks from "./masks";
import media from "./media";
import menu from "./menu";
import number1 from "./number1";
import number2 from "./number2";
import organization from "./organization";
import oriflamme from "./oriflamme";
import oriflammeUser from "./oriflammeUser";
import origin from "./origin";
import outbreak from "./outbreak";
import padlock from "./padlock";
import padlockOpen from "./padlockOpen";
import pages from "./pages";
import pause from "./pause";
import pauseFat from "./pauseFat";
import pencil from "./pencil";
import percent from "./percent";
import pin from "./pin";
import pinPlus from "./pinPlus";
import pinterest from "./pinterest";
import pivotTable from "./pivotTable";
import plus from "./plus";
import polaroid from "./polaroid";
import polygonFunnel from "./polygonFunnel";
import press from "./press";
import publicFigure from "./publicFigure";
import question from "./question";
import radio from "./radio";
import reactions from "./reactions";
import rectangleFunnel from "./rectangleFunnel";
import reddit from "./reddit";
import reply from "./reply";
import reportsListening from "./reportsListening";
import reportsSocialperf from "./reportsSocialperf";
import retweet from "./retweet";
import review from "./review";
import rings from "./rings";
import robotArm from "./robotArm";
import roundArrowCross from "./roundArrowCross";
import scene from "./scene";
import share from "./share";
import sheets from "./sheets";
import shop from "./shop";
import sinaweibo from "./sinaweibo";
import sliders from "./sliders";
import slideshow from "./slideshow";
import smiley from "./smiley";
import smileyTag from "./smileyTag";
import snapchat from "./snapchat";
import snapshotConfirmation from "./snapshotConfirmation";
import soundcloud from "./soundcloud";
import source from "./source";
import speaker from "./speaker";
import speedsearchQueryPlaceholder from "./speedsearchQueryPlaceholder";
import squareArrow from "./squareArrow";
import squarePencil from "./squarePencil";
import star from "./star";
import starCrossed from "./starCrossed";
import starFilled from "./starFilled";
import starHalf from "./starHalf";
import story from "./story";
import suitcase from "./suitcase";
import swipeLeft from "./swipeLeft";
import swipeRight from "./swipeRight";
import table from "./table";
import tag from "./tag";
import tagAuto from "./tagAuto";
import tagCog from "./tagCog";
import tagGeomark from "./tagGeomark";
import tagPadlock from "./tagPadlock";
import tagUser from "./tagUser";
import target from "./target";
import targetPlus from "./targetPlus";
import television from "./television";
import text from "./text";
import tiktok from "./tiktok";
import toneMixed from "./toneMixed";
import toneNegative from "./toneNegative";
import toneNeutral from "./toneNeutral";
import tonePositive from "./tonePositive";
import town from "./town";
import transmitter from "./transmitter";
import trash from "./trash";
import trashBubbles from "./trashBubbles";
import trashFunnel from "./trashFunnel";
import triangleBarLeft from "./triangleBarLeft";
import triangleBarRight from "./triangleBarRight";
import triangleDown from "./triangleDown";
import triangleLeft from "./triangleLeft";
import triangleRight from "./triangleRight";
import triangleUp from "./triangleUp";
import tumblr from "./tumblr";
import tune from "./tune";
import tv from "./tv";
import twitch from "./twitch";
import twitter from "./twitter";
import unplug from "./unplug";
import user from "./user";
import userArrow from "./userArrow";
import userArrowDown from "./userArrowDown";
import userArrowDownLeft from "./userArrowDownLeft";
import userArrowRight from "./userArrowRight";
import userArrowRightTop from "./userArrowRightTop";
import userArrowTop from "./userArrowTop";
import userArrowTopLeft from "./userArrowTopLeft";
import userCircle from "./userCircle";
import userCross from "./userCross";
import userDash from "./userDash";
import userDashboard from "./userDashboard";
import userDollar from "./userDollar";
import userEnveloppe from "./userEnveloppe";
import userFill from "./userFill";
import userOff from "./userOff";
import userPencil from "./userPencil";
import userPlus from "./userPlus";
import userQuote from "./userQuote";
import userTag from "./userTag";
import userTarget from "./userTarget";
import userTransmitter from "./userTransmitter";
import users2 from "./users2";
import users2Circle from "./users2Circle";
import users2Filled from "./users2Filled";
import users3 from "./users3";
import usersBang from "./usersBang";
import verified from "./verified";
import video from "./video";
import videoCircle from "./videoCircle";
import videoCircleBg from "./videoCircleBg";
import vkontakte from "./vkontakte";
import vkontakteGroup from "./vkontakteGroup";
import vkontaktePage from "./vkontaktePage";
import vkontaktePerson from "./vkontaktePerson";
import voronoi from "./voronoi";
import warning from "./warning";
import website from "./website";
import wechat from "./wechat";
import weddingRings from "./weddingRings";
import youku from "./youku";
import youtube from "./youtube";
import youtubeFull from "./youtubeFull";
import zoomOrigin from "./zoomOrigin";

export const GLYPHS = {
  alcmeon: alcmeon,
  "alcmeon-untinted": alcmeonUntinted,
  arobase: arobase,
  "arrow-down": arrowDown,
  "arrow-left": arrowLeft,
  "arrow-right": arrowRight,
  "arrow-sort": arrowSort,
  "arrow-up": arrowUp,
  "arrows-crossing": arrowsCrossing,
  "arrows-invert": arrowsInvert,
  "arrows-reduce": arrowsReduce,
  "arrows-shrinking": arrowsShrinking,
  "arrows-spin": arrowsSpin,
  "arrows-spread": arrowsSpread,
  "arrows-stretching": arrowsStretching,
  asterisk: asterisk,
  bang: bang,
  "bang-fat": bangFat,
  barchart: barchart,
  bilibili: bilibili,
  blog: blog,
  bookmark: bookmark,
  boxes: boxes,
  bubble: bubble,
  "bubble-bang": bubbleBang,
  "bubble-comment": bubbleComment,
  "bubble-dollar": bubbleDollar,
  "bubble-dots": bubbleDots,
  "bubble-graph": bubbleGraph,
  "bubble-lines": bubbleLines,
  "bubble-pencil": bubblePencil,
  "bubble-press": bubblePress,
  "bubble-retweet": bubbleRetweet,
  bubbles: bubbles,
  calendar: calendar,
  camera: camera,
  candles: candles,
  "car-gauge": carGauge,
  "chart-up": chartUp,
  check: check,
  "check-fat": checkFat,
  "checkbox-false": checkboxFalse,
  "checkbox-true": checkboxTrue,
  "chevron-down": chevronDown,
  "chevron-left": chevronLeft,
  "chevron-right": chevronRight,
  "chevron-small-down": chevronSmallDown,
  "chevron-small-left": chevronSmallLeft,
  "chevron-small-right": chevronSmallRight,
  "chevron-small-up": chevronSmallUp,
  "chevron-up": chevronUp,
  "circle-ban": circleBan,
  "circle-bang": circleBang,
  "circle-cross": circleCross,
  "circle-half": circleHalf,
  "circle-info": circleInfo,
  "circle-list": circleList,
  "circle-magnifier": circleMagnifier,
  "circle-question": circleQuestion,
  "circle-user": circleUser,
  circles: circles,
  clock: clock,
  close: close,
  cog: cog,
  comment: comment,
  corners: corners,
  "corners-plus": cornersPlus,
  "corners-tag": cornersTag,
  critizr: critizr,
  cross: cross,
  "cross-thick": crossThick,
  dailymotion: dailymotion,
  danmaku: danmaku,
  dash: dash,
  dashboard: dashboard,
  "dashboard-chart": dashboardChart,
  "dashboard-custom": dashboardCustom,
  device: device,
  disc: disc,
  "disc-close": discClose,
  "disc-pause": discPause,
  "disc-question": discQuestion,
  "discovery-hero-magic-wand": discoveryHeroMagicWand,
  dislike: dislike,
  "dots-3-h": dots3H,
  "dots-3-v": dots3V,
  "dots-grid": dotsGrid,
  douyin: douyin,
  emoji: emoji,
  engagement: engagement,
  envelope: envelope,
  envelopes: envelopes,
  exit: exit,
  eye: eye,
  "eye-crossed": eyeCrossed,
  eyedropper: eyedropper,
  facebook: facebook,
  "facebook-page": facebookPage,
  "facebook-person": facebookPerson,
  "facebook-reaction-angry": facebookReactionAngry,
  "facebook-reaction-haha": facebookReactionHaha,
  "facebook-reaction-like": facebookReactionLike,
  "facebook-reaction-love": facebookReactionLove,
  "facebook-reaction-sad": facebookReactionSad,
  "facebook-reaction-wow": facebookReactionWow,
  feed: feed,
  female: female,
  flag: flag,
  focus: focus,
  folder: folder,
  "folder-funnel": folderFunnel,
  "folder-magnifier": folderMagnifier,
  forum: forum,
  "frame-chart": frameChart,
  "frame-text": frameText,
  funnel: funnel,
  "funnel-cog": funnelCog,
  "funnel-filled": funnelFilled,
  "funnel-minus": funnelMinus,
  "funnel-pencil": funnelPencil,
  "funnel-plus": funnelPlus,
  genders: genders,
  geomark: geomark,
  "geomark-2": geomark2,
  geomarks: geomarks,
  ghost: ghost,
  github: github,
  gplus: gplus,
  graph: graph,
  "graph-arrow": graphArrow,
  "graph-lines": graphLines,
  "graph-podium": graphPodium,
  grid: grid,
  "grid-squares": gridSquares,
  grip: grip,
  "group-bubbles-empty": groupBubblesEmpty,
  gunsight: gunsight,
  hashtag: hashtag,
  heart: heart,
  home: home,
  "hourglass-arrow-cross": hourglassArrowCross,
  "hsp-assign": hspAssign,
  "hsp-reply": hspReply,
  "hsp-retweet": hspRetweet,
  i: i,
  id: id,
  image: image,
  instagram: instagram,
  "instagram-business": instagramBusiness,
  "instagram-personal": instagramPersonal,
  "instagram-untinted": instagramUntinted,
  "layout-1-col": layout1Col,
  "layout-2-cols": layout2Cols,
  "layout-3-cols": layout3Cols,
  lightbulb: lightbulb,
  like: like,
  "lines-3-v": lines3V,
  link: link,
  linkedin: linkedin,
  linkfluence: linkfluence,
  list: list,
  "list-close": listClose,
  "list-open": listOpen,
  littleredbook: littleredbook,
  "live-help": liveHelp,
  "lo-dash": loDash,
  "load-down": loadDown,
  "load-up": loadUp,
  loader: loader,
  localisation: localisation,
  magic: magic,
  "magic-wand": magicWand,
  "magic-wand-cursor": magicWandCursor,
  "magic-wand-gradient": magicWandGradient,
  magnifier: magnifier,
  "magnifier-plus": magnifierPlus,
  male: male,
  masks: masks,
  media: media,
  menu: menu,
  "number-1": number1,
  "number-2": number2,
  organization: organization,
  oriflamme: oriflamme,
  "oriflamme-user": oriflammeUser,
  origin: origin,
  outbreak: outbreak,
  padlock: padlock,
  "padlock-open": padlockOpen,
  pages: pages,
  pause: pause,
  "pause-fat": pauseFat,
  pencil: pencil,
  percent: percent,
  pin: pin,
  "pin-plus": pinPlus,
  pinterest: pinterest,
  "pivot-table": pivotTable,
  plus: plus,
  polaroid: polaroid,
  "polygon-funnel": polygonFunnel,
  press: press,
  "public-figure": publicFigure,
  question: question,
  radio: radio,
  reactions: reactions,
  "rectangle-funnel": rectangleFunnel,
  reddit: reddit,
  reply: reply,
  "reports-listening": reportsListening,
  "reports-socialperf": reportsSocialperf,
  retweet: retweet,
  review: review,
  rings: rings,
  "robot-arm": robotArm,
  "round-arrow-cross": roundArrowCross,
  scene: scene,
  share: share,
  sheets: sheets,
  shop: shop,
  sinaweibo: sinaweibo,
  sliders: sliders,
  slideshow: slideshow,
  smiley: smiley,
  "smiley-tag": smileyTag,
  snapchat: snapchat,
  "snapshot-confirmation": snapshotConfirmation,
  soundcloud: soundcloud,
  source: source,
  speaker: speaker,
  "speedsearch-query-placeholder": speedsearchQueryPlaceholder,
  "square-arrow": squareArrow,
  "square-pencil": squarePencil,
  star: star,
  "star-crossed": starCrossed,
  "star-filled": starFilled,
  "star-half": starHalf,
  story: story,
  suitcase: suitcase,
  "swipe-left": swipeLeft,
  "swipe-right": swipeRight,
  table: table,
  tag: tag,
  "tag-auto": tagAuto,
  "tag-cog": tagCog,
  "tag-geomark": tagGeomark,
  "tag-padlock": tagPadlock,
  "tag-user": tagUser,
  target: target,
  "target-plus": targetPlus,
  television: television,
  text: text,
  tiktok: tiktok,
  "tone-mixed": toneMixed,
  "tone-negative": toneNegative,
  "tone-neutral": toneNeutral,
  "tone-positive": tonePositive,
  town: town,
  transmitter: transmitter,
  trash: trash,
  "trash-bubbles": trashBubbles,
  "trash-funnel": trashFunnel,
  "triangle-bar-left": triangleBarLeft,
  "triangle-bar-right": triangleBarRight,
  "triangle-down": triangleDown,
  "triangle-left": triangleLeft,
  "triangle-right": triangleRight,
  "triangle-up": triangleUp,
  tumblr: tumblr,
  tune: tune,
  tv: tv,
  twitch: twitch,
  twitter: twitter,
  unplug: unplug,
  user: user,
  "user-arrow": userArrow,
  "user-arrow-down": userArrowDown,
  "user-arrow-down-left": userArrowDownLeft,
  "user-arrow-right": userArrowRight,
  "user-arrow-right-top": userArrowRightTop,
  "user-arrow-top": userArrowTop,
  "user-arrow-top-left": userArrowTopLeft,
  "user-circle": userCircle,
  "user-cross": userCross,
  "user-dash": userDash,
  "user-dashboard": userDashboard,
  "user-dollar": userDollar,
  "user-enveloppe": userEnveloppe,
  "user-fill": userFill,
  "user-off": userOff,
  "user-pencil": userPencil,
  "user-plus": userPlus,
  "user-quote": userQuote,
  "user-tag": userTag,
  "user-target": userTarget,
  "user-transmitter": userTransmitter,
  "users-2": users2,
  "users-2-circle": users2Circle,
  "users-2-filled": users2Filled,
  "users-3": users3,
  "users-bang": usersBang,
  verified: verified,
  video: video,
  "video-circle": videoCircle,
  "video-circle-bg": videoCircleBg,
  vkontakte: vkontakte,
  "vkontakte-group": vkontakteGroup,
  "vkontakte-page": vkontaktePage,
  "vkontakte-person": vkontaktePerson,
  voronoi: voronoi,
  warning: warning,
  website: website,
  wechat: wechat,
  "wedding-rings": weddingRings,
  youku: youku,
  youtube: youtube,
  "youtube-full": youtubeFull,
  "zoom-origin": zoomOrigin,
};
